import React from "react";
import { Result, Button } from "antd";
import { useHistory } from "react-router-dom";
import I18n from "../../i18n";
import { DocumentTitle } from "../../components";

export default function NotFound() {
  const history = useHistory();

  return (
    <DocumentTitle title={undefined}>
      <Result
        status="404"
        title="404"
        subTitle={I18n.general.notFound404}
        extra={
          <Button type="primary" onClick={() => history.push("/")}>
            {I18n.general.mainPage}
          </Button>
        }
      />
    </DocumentTitle>
  );
}
